import { gql } from "@apollo/client";

export const LIST_CLIENTS = gql`
  query listClients($filter: ListEntitiesFilter!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listEntities(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        code
        name
        vatNumber
        annualRevenue
      }
    }
  }
`;

export const LIST_ENTITIES_WITH_SEARCH_VAR = gql`
  query listEntities(
    $search: String
    $company: ID
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listEntities(filter: { search: $search, companyId: $company }) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        code
        name
        vatNumber
      }
    }
  }
`;

export const GET_CLIENT = gql`
  query getEntity($id: ID!) {
    getEntity(id: $id) {
      id
      code
      name
      vatNumber
      euVatNumber
      companyBankAccountId
      nic
      chorus
      comments
      emails {
        id
        email
        type
      }
      phones {
        id
        number
        type
        prefix
        country
        type
      }
      company {
        id
        name
      }
      legalStructure {
        code
        name
      }
      categoryType {
        label
        value
      }
      addresses {
        id
        name
        streetName
        streetNameComplement
        addressNr
        addressBtq
        postalCode
        city
        addressType {
          label
          value
        }
        country {
          code
          name
        }
      }
    }
  }
`;

export const CREATE_ENTITY_ADDRESS = gql`
  mutation createEntityAddress($input: EntityAddressInput!) {
    createEntityAddress(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_ENTITY_ADDRESS = gql`
  mutation updateEntityAddress($input: EntityAddressUpdateInput!) {
    updateEntityAddress(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const LIST_CLIENT_TYPE_CHOICES = gql`
  query listClientTypeChoices {
    listCategoryChoices {
      label
      value
    }
  }
`;

export const LIST_ADDRESS_TYPE_CHOICES = gql`
  query listAddressTypeChoices {
    listAddressTypes {
      label
      value
    }
  }
`;

export const LIST_CLIENT_ADDRESSES = gql`
  query listEntityAddresses($filter: ListEntityAddressesFilter!, $offset: Int, $limit: Int) {
    listEntityAddresses(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit) {
        id
        name
        streetName
        streetNameComplement
        postalCode
        country {
          code
          name
        }
        city
        addressBtq
        addressNr
        addressType {
          label
          value
        }
      }
    }
  }
`;

export const GET_CLIENT_ADDRESS = gql`
  query getClientAddress($id: ID!) {
    getEntityAddress(id: $id) {
      id
      name
      streetName
      streetNameComplement
      postalCode
      country {
        code
        name
      }
      city
      addressBtq
      addressNr
      addressType {
        label
        value
      }
    }
  }
`;

export const DELETE_ENTITY_ADDRESS = gql`
  mutation deleteEntityAddress($id: ID!) {
    deleteEntityAddress(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_CLIENT = gql`
  mutation deleteClient($id: ID!) {
    deleteClient(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_CLIENT_SIMPLE = gql`
  query getClient($id: ID!) {
    getEntity(id: $id) {
      id
      name
      code
    }
  }
`;

export const LIST_CLIENTS_PAGINATED_SELECT = gql`
  query listEntities($filter: ListEntitiesFilter!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listEntities(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        vatNumber
        code
      }
    }
  }
`;

export const CREATE_CLIENT_EMAIL = gql`
  mutation createEntityEmail($input: EntityEmailInput!) {
    createEntityEmail(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CLIENT_EMAIL = gql`
  mutation updateEntityEmail($input: EntityEmailUpdateInput!) {
    updateEntityEmail(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CLIENT_PHONE = gql`
  mutation updateEntityPhone($input: EntityPhoneUpdateInput!) {
    updateEntityPhone(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_CLIENT_PHONE = gql`
  mutation createEntityPhone($input: EntityPhoneInput!) {
    createEntityPhone(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_CLIENT_EMAIL = gql`
  query getEntityEmail($id: ID!) {
    getEntityEmail(id: $id) {
      id
      email
      type
    }
  }
`;

export const GET_CLIENT_PHONE = gql`
  query getEntityPhone($id: ID!) {
    getEntityPhone(id: $id) {
      id
      number
      type
      prefix
      country
    }
  }
`;
